import React from 'react';
import { DefaultButton, IButtonStyles } from '@fluentui/react';

const styles : IButtonStyles = {
    root: {
        backgroundColor: 'var(--color-primario)',
        color: 'white',
        borderColor: 'white',
        borderRadius: '50%',
        width: 48,
        minWidth: 48,
        height: 48,
        minHeight: 48,
    },
    rootHovered: {
        backgroundColor: 'white',
        color: 'var(--color-primario)',
        borderColor: 'var(--color-primario)',
    },
    label: {
        fontWeight: 500,
    },
};

interface IButtonPrimaryRoundedComponentProps {
    icon?: string,
    onClick?: (event: any) => void;
    className?: string;
};

const ButtonPrimaryRoundedComponent = (props: IButtonPrimaryRoundedComponentProps) => {
    return (
        <DefaultButton
            className={props.className}
            onClick={props.onClick}
            iconProps={props.icon ? {
                iconName: props.icon,
            } : {}}
            styles={styles} />
    );
};

export default ButtonPrimaryRoundedComponent;
